import { render, staticRenderFns } from "./awardDetailGift.vue?vue&type=template&id=351ece73&scoped=true"
import script from "./awardDetailGift.vue?vue&type=script&lang=js"
export * from "./awardDetailGift.vue?vue&type=script&lang=js"
import style0 from "./awardDetailGift.vue?vue&type=style&index=0&id=351ece73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351ece73",
  null
  
)

export default component.exports